import { useEffect, useState } from "react";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loading, Empty } from "../components/kit";
import PeriodBar from "../components/PeriodBar";
import StaffPerformanceView from "../components/StaffPerformanceView";
import { MyMto } from "../components/mto/MtoPanels";
import { Link } from "react-router-dom";
import { BellRing, ChevronRight } from "lucide-react";
import { monthLabel, fmtDate } from "../lib/format";

export default function MyPerformance() {
  const { user, basis, range } = useAuth();
  const [d, setD] = useState(null);
  const [cats, setCats] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!range) return;
    Promise.all([api.get("/performance/me", { params: { basis, start: range.start, end: range.end } }), api.get("/categories")])
      .then(([p, c]) => { setD(p.data); setCats(c.data); })
      .catch((e) => setErr(errMsg(e)));
  }, [basis, range]);

  if (err) return <Empty>{err}</Empty>;
  if (!d) return <Loading />;
  return (
    <div>
      <div className="mb-6 bs-rise">
        <div className="bs-eyebrow">{d.store_info.name} · {monthLabel(d.days.as_of.slice(0, 7))}</div>
        <h1 className="font-display text-4xl font-extrabold text-[#011E38] tracking-tight mt-1" data-testid="my-performance-title">MY PERFORMANCE</h1>
        <div className="text-slate-500 mt-1">Hi {user.name}</div>
      </div>
      <PeriodBar />
      <div>
      </div>
      {d.today_entry?.working && !d.today_entry.submitted && (!d.today_entry.day_status || d.today_entry.day_status.leave_status === "rejected") && (
        <Link to="/entry" className="flex items-center gap-3 rounded-2xl border border-orange-200 bg-orange-50 px-4 py-4 mb-6 bs-rise" data-testid="pending-entry-banner">
          <BellRing className="w-6 h-6 text-orange-600 shrink-0" />
          <div className="flex-1">
            <div className="font-display font-bold text-orange-800 text-lg leading-tight">Today's entry is pending</div>
            <div className="text-sm text-orange-700">Submit your sales for {fmtDate(d.today_entry.date)} — it takes under a minute.</div>
          </div>
          <ChevronRight className="w-5 h-5 text-orange-600" />
        </Link>
      )}
      <StaffPerformanceView d={d} cats={cats} />
      <MyMto range={range} />
    </div>
  );
}
